import React from 'react';

function AdminDashboard() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">AdminDashboard</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">This page is under construction.</p>
        <p className="text-sm text-gray-500 mt-2">Check the implementation guide for details on how to build this feature.</p>
      </div>
    </div>
  );
}

export default AdminDashboard;
